import PropTypes from 'prop-types'

import Controls from '@aytm/app/stats/page/question-views/mn/Controls'
import ViewModeDropdown from '@aytm/app/stats/page/question-views/mn/ViewModeDropdown'

const SectionMetricsControls = ({ title, options, viewMode, collapsed, onModelChange, onToggle }) => (
  <Controls title={title} collapsed={collapsed} onToggle={onToggle}>
    <ViewModeDropdown options={options} value={viewMode} width={300} onChange={onModelChange} />
  </Controls>
)

SectionMetricsControls.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  viewMode: PropTypes.string,
  collapsed: PropTypes.bool,
  onModelChange: PropTypes.func,
  onToggle: PropTypes.func
}

SectionMetricsControls.displayName = 'SectionMetricsControls'

export default SectionMetricsControls
